import { Action } from '@ngrx/store';

export enum TabActions {
    OpenTransactionTab = '[Transaction Tab] OpenTransactionTab ',
}
export class OpenTransactionTab implements Action {
    readonly type = TabActions.OpenTransactionTab;
    constructor(public transactionId: string) {}
}
export type TabAction = OpenTransactionTab;
